import React, { FC } from "react";

import {
  useApisManagersBelongingEmployeesPrivateQuestionAnswersIndex,
  useSearchManagersPrivateQuestionAnswers,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { ManagersPrivateQuestionAnswersIndexTemplate } from "~/components/templates";

import { TabItemLinks } from "~/ui";

export const ManagersBelongingEmployeesPrivateQuestionAnswersIndex: FC = () => {
  const {
    privateQuestionAnswers,
    keyword,
    isLoading,
    hasNextPage,
    startDate,
    endDate,
    selectableDropdownEmployees,
    selectedDropdownEmployees,
    onChangeDropdownEmployees,
    fetchNextPage,
    onChangeDateRange,
    onChangeKeyword,
    onConditionReset,
    onSearchSubmit,
  } = useSearchManagersPrivateQuestionAnswers({
    useApisPrivateQuestions:
      useApisManagersBelongingEmployeesPrivateQuestionAnswersIndex,
  });

  const breadCrumbItems = [
    { label: "Q&A", href: "/managers/question_answer_categories" },
    { label: "メンバーの投稿", href: "/managers/private_question_answers" },
  ];

  return (
    <EmployeeLayout withRightSidebar={false} breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar={false}>
        <TabItemLinks
          items={[
            {
              name: "チームに蓄積",
              href: "/managers/private_question_answers",
              isActive: false,
            },
            {
              name: "同じ課のユーザーのすべての投稿を確認",
              href: "/managers/belonging_employees/private_question_answers",
              isActive: true,
            },
          ]}
        />
        <ManagersPrivateQuestionAnswersIndexTemplate
          className="mt-8"
          privateQuestionAnswers={privateQuestionAnswers}
          keyword={keyword}
          isLoading={isLoading}
          hasNextPage={hasNextPage}
          startDate={startDate}
          endDate={endDate}
          selectableDropdownEmployees={selectableDropdownEmployees}
          selectedDropdownEmployees={selectedDropdownEmployees}
          onChangeDropdownEmployees={onChangeDropdownEmployees}
          fetchNextPage={fetchNextPage}
          onChangeDateRange={onChangeDateRange}
          onChangeKeyword={onChangeKeyword}
          onConditionReset={onConditionReset}
          onSearchSubmit={onSearchSubmit}
        />
      </EmployeeLayoutMainContent>
    </EmployeeLayout>
  );
};
